/**
 * helper to check newrow room status
 */
import { baseUrl } from "@kaltura/mediaspace-shared-utils";
import { browserName, browserVersion } from "react-device-detect";
import { MeetingRoomType } from "./MeetingRoomType";

export class MeetingRoomHelper {
    /**
     * check if the room connected to the given entry is currently live
     * @param entryId
     */
    static pollRoom(entryId: string, isReadOnly?: boolean): Promise<boolean> {
        if (!entryId) {
            return Promise.reject("missing entry id");
        }
        // go to KMS url with the entry id to check if the room is live
        let url = baseUrl + "/meetingentry/newrow/check-alive/entryid/" + entryId + "?format=script";
        if (isReadOnly) {
            url = `${url}&isReadOnly=true`;
        }
        const myRequest = new Request(url);

        return fetch(myRequest).then(function (response: Response) {
            if (!response.ok) {
                return Promise.reject(response);
            }

            return Promise.resolve(response.json());
        });
    }

    static updateRoomStatus(type: MeetingRoomType, roomId: string, isReadOnly?: boolean): void {
        // go to KMS url with the entry id to set the room status active
        let url = `${baseUrl}/newrow/index/room-live/type/${type}/roomId/${roomId}?format=ajax`;
        if (isReadOnly) {
            url = `${url}&isReadOnly=true`;
        }
        const myRequest = new Request(url);

        fetch(myRequest).then(function (response: Response) {
            if (!response.ok) {
                console.log(`failed to update room status for ${type} ${roomId}`);
            }
        });
    }

    /**
     * update room status in KMS as closed
     */
    static clearRoomStatus(type: MeetingRoomType, roomId: string, isReadOnly?: boolean) {
        // go to KMS url with the entry id to set the room status active
        let url = `${baseUrl}/newrow/index/room-close/type/${type}/roomId/${roomId}?format=ajax`;
        if (isReadOnly) {
            url = `${url}&isReadOnly=true`;
        }
        const myRequest = new Request(url);

        return fetch(myRequest).then(function (response: Response) {
            if (!response.ok) {
                console.log(`failed to clear room status for ${type} id ${roomId}`);
            }
        });
    }

    /**
     * check if current browser supports the meeting room
     */
    static isNewrowSupportedInCurrentBrowser = (safariSupport = false) => {
        const isSupportedVersion = (name: string, version: number) => {
            if (browserName !== name) {
                return false;
            }
            return Number(browserVersion) > version;
        };
        return (
            isSupportedVersion("Chrome", 65)
            || isSupportedVersion("Firefox", 59)
            || isSupportedVersion("Edge", 81)
            || (safariSupport && ["Safari", "Mobile Safari"].includes(browserName))
        );
    };
}
